import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BarChart from '@/features/reports/components/chartjs/BarChart.vue';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';
import ChartError from '@/features/reports/components/ChartError.vue';
import ChartLabels from '@/features/reports/components/ChartLabels.vue';
import ChartNoData from '@/features/reports/components/ChartNoData.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import { Data, SeriesConfig } from '@/features/reports/models';
import { nanoid } from 'nanoid';
import { computed, PropType, ref } from 'vue';
import { useReportData } from '@/features/reports/util/useReportData';
import Report from '@/features/reports/components/Report.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChannelMessagesTrendChart',
  props: {
  data: {
    type: Object as PropType<Data>,
    required: true,
  },
  loadedData: {
    type: Boolean,
    default: false,
  },
  loadingError: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const { reportId, isDataLoaded, isDataEmpty } = useReportData(props);

const seriesOrder = computed(() => {
  const channels: SeriesConfig[] = [
    { name: 'BT Smart Messaging Tailored', displayName: 'BT Smart Messaging Tailored', colour: '#5614B4' },
    { name: 'GOV.UK Notify SMS', displayName: 'GOV.UK Notify SMS', colour: '#000000' },
    { name: 'Instagram', displayName: 'Instagram', colour: '#E1306C' },
    { name: 'Whatsapp', displayName: 'WhatsApp', colour: '#0E3926' },
    { name: 'Messenger', displayName: 'Messenger', colour: '#006AFF' },
    { name: 'Web Assistant', displayName: 'Web Assistant', colour: '#062B80' },
  ];

  return channels.filter((c) => {
    return props.data.series.some((s) => s.name === c.name);
  });
});

const reportData = computed<Data>(() => ({
  scale: props.data.scale,
  series: props.data.series,
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Report, {
    "report-id": _unref(reportId),
    title: "Channel Messages",
    "tooltip-text": "A trend showing the total sent and received messages for each channel.",
    class: "chart-container",
    "data-empty": _unref(isDataEmpty),
    "loaded-data": _unref(isDataLoaded),
    "loading-error": __props.loadingError
  }, {
    chart: _withCtx(() => [
      _createVNode(BarChart, {
        reportId: _unref(reportId),
        class: "chart",
        data: reportData.value,
        seriesOrder: seriesOrder.value
      }, null, 8, ["reportId", "data", "seriesOrder"])
    ]),
    _: 1
  }, 8, ["report-id", "data-empty", "loaded-data", "loading-error"]))
}
}

})